/*
==========================
Buttons
==========================

Usage example:

<Button color="blue" size="large">

*/

import styled, { css } from 'styled-components'
import {breakpoint} from "./styles";

export const Button = styled.a<any>`
  background: black;
  color: white;
  padding: 10px 20px;
  border-radius: 2.5px;
  font-size: 16px;

  ${({color}) => color == 'blue' && css`
    color: var(--white);
    background-color: var(--secondary-color);
    &:hover, &:focus {
        color: var(--white);
        background-color: var(--accent-color);
    }
  `}

  ${({color}) => color == 'white' && css`
    background-color: var(--white);
    color: var(--tertiary-color);
    &:hover, &:focus {
        color: var(--white);
        background-color: var(--black);
    }
  `}

  ${({color, text}) => color == 'white' && text == 'blue' && css`
    background-color: var(--white);
    color: var(--secondary-color);
    &:hover, &:focus {
        color: var(--white);
        background-color: var(--black);
    }
  `}

  ${({color}) => color == 'red' && css`
    background-color: var(--red);
    color: var(--white);
    &:hover, &:focus {
        color: var(--red);
        background-color: var(--white);
        box-shadow: inset 0 0 0 2px var(--red);
    }
  `}

  ${({color}) => color == 'transparent' && css`
    background-color: transparent;
    box-shadow: inset 0 0 0 2px var(--white);
    color: var(--white);
    &:hover, &:focus {
        color: var(--blue);
        background-color: var(--white);
    }
  `}

  ${({size}) => size == 'large' && css`
    font-weight: 800;
    font-size: 1.375rem;
    min-height: 3.625rem;
    padding: .875rem 2.5rem 0.9375rem;
    @media ${breakpoint.desktop} {
    font-size: 1.5625rem;
    }
    &:hover, &:focus {
        padding: .875rem 2.5rem 0.9375rem;
    }
  `}

`

export default Button;
